import styled from 'styled-components/macro';

const AfLoanContactCardWrapper = styled.li`
  margin: 0 0 10px 0;
`;

export default AfLoanContactCardWrapper;
